// extracted by mini-css-extract-plugin
module.exports = {"custom-scrollbar":"styles_custom-scrollbar__309d3"};